import { OnInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from 'src/app/core/services/dashboard/dashboard.service';
import { UserService } from 'src/app/core/user/user.service';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {CookieService} from "ngx-cookie-service";

@Component({
  selector: 'app-modal-visites',
  templateUrl: './modal-visites.component.html',
  styleUrls: ['./modal-visites.component.scss'],
})
export class ModalVisitesComponent implements OnInit {
  @Input() bien: any;
  @Input() nbVisites: any;
  @Input() colorIcon = 'white';

  userConnected?: any = {};
  VisitesData: any;
  isLoadedHttp = false;
  localMarket: any;

  messageConfirmation: any = '';
  statusConfirmation = 'success';
  showAlert = false;
  readOnly = false;
  constructor(
    private modalService: NgbModal,
    private router: Router,
    private _userService: UserService,
    private _dashboardService: DashboardService,
    private http: HttpClient,
    private _cookieService: CookieService
  ) {}

  ngOnInit() {
    this.userConnected = this._userService.getUser();
  }

  getVisitesData() {
    this.isLoadedHttp = false;

    this._dashboardService
      .getMesVisites(this.bien.id)
      .subscribe((response: any) => {
        this.isLoadedHttp = true;
        if (response.code === 200) {
          this.VisitesData = response.data;
          this.VisitesData.sort((a: any, b: any) => {
            if (a.start < b.start) return 1;
            else if (a.start > b.start) return -1;
            else return 0;
          });
        }
      });
  }
  checkLocalMarket(data: any) {
    if (data.local_market_expert) {
      return data.local_market_expert.name;
    }
    return this.localMarket;
  }
  openVertically(content: any) {
    this.VisitesData = [];
    this.getVisitesData();
    this.showAlert = false;
    this.messageConfirmation = '';
    this.modalService.open(content, { size: 'xl' });
  }
}
